module.exports = __webpack_public_path__ + "static/icons/icon-close-5662d6ff06cea05a103608c4457829c7.svg";